package modysy

import org.scalajs.dom
import org.scalajs.dom.html.Audio

class AudioPlayer {

  private val audioElement: Audio =
    dom.document.createElement("AUDIO").asInstanceOf[Audio]

  private var _source: String = ""

  audioElement.setAttribute("paused", "true")
  dom.document.body.appendChild(audioElement)

  def setAudio(source: String): Unit = {
    this.audioElement.setAttribute("src", source)
    _source = source
  }

  def playAudio()
    : Unit = { audioElement.play() } //audioElement.setAttribute("paused", "false") }
  def pauseAudio()
    : Unit = { audioElement.pause() } //audioElement.setAttribute("paused", "true") }

  def resetAudio(): Unit = { audioElement.load() }

  def playing: Boolean = !audioElement.paused

  def setLoop(value: Boolean): Unit = {
    audioElement.loop = value
  }

  def source: String = _source

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/AudioPlayer.scala